import React, { Component, Fragment } from 'react';

import { Form } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import setFieldData from 'final-form-set-field-data'

import {
  Typography,
  Paper,
  Grid,
  Button,
  CircularProgress,
} from '@material-ui/core';

import {
  formInput,
} from '../components/FormFields';
import AutoSave from '../components/Autosave'

import './Job.css';

import jobList from './jobList.jsx';
import jobDuty from './jobDuty.jsx';

import metadata from '../metadata'
import EnrollDescription from '../enrollment/Enroll-description';

class Job extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    }

    this.storageKey = 'scccs-summercamp-application-job';

    this.onSubmit = this.onSubmit.bind(this);
    this.save = this.save.bind(this);
  }
  componentDidMount() {
    this.load();
  }

  load() {
    const params = new URLSearchParams(this.props.location.search);
    const id = params.get('id');
    if (id) {
      return this.loadFromServer(id);
    } else {
      return this.loadFromLocalStorage();
    }
  }

  loadFromServer(id) {
    return Promise.resolve()
      .then(() => {
        const url = `${metadata.apiUrl}/job/${id}`;
        const params = {
          method: 'GET',
          mode: 'cors',
          headers: {
            'x-api-key': metadata.apiKey,
          },
        };
        return fetch(url, params).then((response) => {
          if (response.status !== 200) {
            return Promise.reject(response);
          }
          return response.json();
        })
      })
      .then((res) => {
        this.setState({
          loading: false,
          data: res.data,
        });
      })
      .catch((err) => {
        return this.loadFromLocalStorage();
      });
  }

  loadFromLocalStorage() {
    let data = {};
    try {
      data = JSON.parse(localStorage.getItem(this.storageKey)) || {};
    } catch (e) {
      // 
      console.log(e);
    }

    this.setState({
      loading: false,
      data
    });
  }

  save(inValues = {}) {
    try {
      let currentData = JSON.parse(localStorage.getItem(this.storageKey)) || {};
      const toSaveData = Object.assign(currentData, inValues);
      // console.log('saving data', toSaveData);
      localStorage.setItem(this.storageKey, JSON.stringify(toSaveData));
    } catch (e) {
      // 
      console.log(e);
    }
  }

  alert(msg) {
    return new Promise((resolve, reject) => {
      const r = window.confirm(msg);
      return (r) ? resolve() : reject();
    });
  }

  reset() {
    localStorage.setItem(this.storageKey, JSON.stringify({}));
  }

  resetConfirm(form) {
    this.alert('Do you want to reset the whole application form?')
      .then(() => {
        if (form && form.reset) {
          form.reset();
        }
        this.reset();
        this.load();
        this.save();
      })
      .catch(() => {})
  }

  onSubmit(values) {
    return Promise.resolve()
      .then(() => {
        const url = `${metadata.apiUrl}/job`;
        const params = {
          method: 'POST',
          mode: 'cors',
          headers: {
            'x-api-key': metadata.apiKey,
          },
          body: JSON.stringify(values),
        };
        return fetch(url, params).then((response) => {
          if (response.status !== 200) {
            return Promise.reject(response);
          }
          return response.json();
        })
      })
      .then((res) => {
        console.log(res);
        this.reset();
        window.open(`/jobApplicationCompleted?id=${res.data.id}&autoDownload=true`, '_self');
      })
      .catch(console.log);
  }

  renderSection(inSectionName, inRoleNames, inForm) {
    if (!jobList.sections[inSectionName]) return;
    const { label, description, fields, condition } = jobList.sections[inSectionName];

    if (condition && !condition(inRoleNames)) return;

    return (
      <Paper className="paper-container">
      <Typography variant="h5">{label}</Typography>
      <hr></hr>
      {description && (typeof(description) === 'function')? description() : <p>{description}</p>}
      <Grid container alignItems="flex-start" spacing={8}>
        {
          fields.map((item, index)=>{
            return (<Grid key={index} item xs={item.xs || 12} md={item.md || 12}>
              {item.guide && <p>{item.guide}</p>}
              {item.func(item.key, item.label, item.required, item.options, '', false, inForm)}
            </Grid>)
          })
        }
      </Grid>
    </Paper>);
  }

  render() {
    return (
      <Grid container className="main" justify="center">
        <Grid item xs={12} sm={10} md={8}>

        <EnrollDescription/>
        
        {this.state.loading && 
          <Grid item xs={12} align="center">
            <CircularProgress />
          </Grid>}

        {!this.state.loading && 
        <Form
          onSubmit={this.onSubmit}
          mutators={{ setFieldData, ...arrayMutators }}
          // validate={validate}
          initialValues={this.state.data}
          render={({
            handleSubmit,
            pristine,
            form,
            submitting,
            // validating,
            values,
          }) => {
            form.values = values;
            return (
              <form onSubmit={handleSubmit}>
                <AutoSave debounce={3000} save={this.save} />

                {Object.keys(jobList.sections).map((key, index)=>{
                  return (<Fragment key={index}>
                    {this.renderSection(key, values.roles, form)}
                  </Fragment>)
                })}

                {
                  values.roles && values.roles.map((role, index)=>{
                    if(!jobDuty.duties[role]) return '';
                    const {label, description, key} = jobDuty.duties[role];
                    return (<Fragment key={index}>
                      <Paper className="paper-container">
                        <Typography variant="h5">{label}</Typography>
                        <hr></hr>
                        {description && description()}
                        <Grid container alignItems="flex-start" spacing={8}>
                          <p>E-Signature By typing my name below, I certify that I am over the Age of 18.  If I am under 18, then my Parent/Guardian will also type his/her name here as agreeing to all the terms, conditions, and rules.</p>
                          {formInput(key, 'E-Signature Here')}
                        </Grid>
                      </Paper>
                    </Fragment>)
                  })
                }

                <Grid container alignItems="flex-start" spacing={8} style={{ 'marginTop': '20px' }}>
                  <Grid item xs={12} align="center">
                    {/* <Button 
                      variant="outlined"
                      color="primary"
                      onClick={()=>{
                        generateAndDownloadForms(values);
                      }}                      >
                      Download Forms (test)
                    </Button>
                    &nbsp; */}
                    <Button 
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={submitting}
                        >
                        Submit Application
                      </Button>
                      &nbsp;
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={()=>{
                          this.resetConfirm(form);
                        }}
                        disabled={submitting}
                        >
                        Reset
                      </Button>
                  </Grid>
                </Grid>
                {/* <div className="test-output">
                  <pre>{JSON.stringify((values || {}), 0, 2)}</pre>
                  {console.log(values)}
                </div> */}
              </form>
            )
          }}
        />}
        </Grid>
    </Grid>);
  }
}

export default Job;
